import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Tooltip } from '../../../BaseComponents';
import { useTheme } from '../../../theme';
const AgreementCheckbox = ({ showTooltip, tooltipTitle, classes, fieldName, checked, label, required, onChange }) => {
    const { AgreementCheckbox: css } = useTheme('AgreementCheckboxWrapper');
    const openTooltip = showTooltip && !checked && required && !!tooltipTitle;
    return (React.createElement(FormControlLabel, { control: React.createElement(Tooltip, { open: openTooltip, title: tooltipTitle, placement: "top-start" },
            React.createElement(Checkbox, { color: "primary", classes: {
                    root: css.checkbox,
                    checked: css.checkbox_checked
                }, checked: checked, onClick: () => onChange(fieldName) })), value: checked, label: label }));
};
export default AgreementCheckbox;
